'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//  weak
var ResponderLists = function () {
    function ResponderLists() {
        (0, _classCallCheck3.default)(this, ResponderLists);

        this.validateByPath = {};
        this.updateByPath = {};
        this.swapByPath = {};
        this.showByPath = {};
        this.hideByPath = {};
        this.swappedBefore = {};

        this.all = [this.validateByPath, this.updateByPath, this.swapByPath, this.showByPath, this.hideByPath, this.swappedBefore];
    }

    (0, _createClass3.default)(ResponderLists, [{
        key: 'toString',
        value: function toString() {
            var s = 'ResponderLists [';

            for (var variable in this) {
                // $FlowFixMe
                var list = this[variable];

                if (this.all.indexOf(list) > -1) {
                    var contents = [];
                    for (var key in list) {
                        contents.push('[' + key + ' = ' + list[key] + ']'); // eslint-disable-line prefer-template
                    }
                    s += '\n\t[' + variable + ': ' + contents.join(', ') + '], '; // eslint-disable-line prefer-template
                }
            }

            s += ']';
            return s;
        }
    }]);
    return ResponderLists;
}();

exports.default = ResponderLists;
//# sourceMappingURL=ResponderLists.js.map